import { render, staticRenderFns } from "./LabelNormal.vue?vue&type=template&id=27277b5e&scoped=true&"
import script from "./LabelNormal.vue?vue&type=script&lang=js&"
export * from "./LabelNormal.vue?vue&type=script&lang=js&"
import style0 from "./LabelNormal.vue?vue&type=style&index=0&id=27277b5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27277b5e",
  null
  
)

export default component.exports